import { useMemo } from 'react';

type VerificationLinkData = {
  tokenHash: string | null;
  type: string | null;
  wrappedLink: string | null;
};

export function useSupabaseVerificationLink(): VerificationLinkData {
  return useMemo(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const wrappedLink = urlParams.get('link');

    if (!wrappedLink) {
      return {
        tokenHash: null,
        type: null,
        wrappedLink: null,
      };
    }

    try {
      const supabaseUrl = new URL(wrappedLink);

      return {
        tokenHash: supabaseUrl.searchParams.get('token'),
        type: supabaseUrl.searchParams.get('type'),
        wrappedLink,
      };
    } catch (error) {
      console.error('❌ Failed to parse Supabase verification link:', error);
      return {
        tokenHash: null,
        type: null,
        wrappedLink: null,
      };
    }
  }, []);
}
